export const SalesTaxChat = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4227_18037)">
      <path
        d="M16 8C16 6.916 15.524 5.89333 14.7167 5.25067C14.81 4.16933 14.4233 3.11 13.6567 2.34267C12.89 1.57667 11.8333 1.18867 10.8053 1.306C9.46268 -0.397999 6.56201 -0.429999 5.25068 1.28267C3.09535 1.02667 1.02268 3.056 1.30668 5.19467C-0.39732 6.53733 -0.429986 9.438 1.28335 10.75C1.19001 11.8313 1.57668 12.8907 2.34335 13.658C3.11001 14.424 4.16801 14.812 5.19468 14.6947C6.53735 16.3987 9.43801 16.4307 10.7493 14.718C11.8293 14.8107 12.8893 14.4253 13.6567 13.658C14.4227 12.8913 14.8093 11.8313 14.6933 10.8067C15.524 10.108 16 9.08533 16 8.00133V8ZM5.33335 6C5.33735 5.128 6.66268 5.128 6.66668 6C6.66268 6.872 5.33735 6.872 5.33335 6ZM7.22135 10.37C7.01601 10.6787 6.59935 10.7573 6.29668 10.5547C5.99001 10.3507 5.90735 9.93667 6.11201 9.63L8.77868 5.63C8.98268 5.324 9.39602 5.24 9.70335 5.44533C10.01 5.64933 10.0927 6.06333 9.88801 6.37L7.22135 10.37ZM10 10.6667C9.12801 10.6627 9.12801 9.33733 10 9.33333C10.872 9.33733 10.872 10.6627 10 10.6667Z"
        fill="url(#paint0_linear_4227_18037)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4227_18037"
        x1="8.00672"
        y1="0.0130005"
        x2="8.00672"
        y2="15.9877"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9878FD" />
        <stop offset="1" stopColor="#482F99" />
      </linearGradient>
      <clipPath id="clip0_4227_18037">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
